(() => {
  angular
    .module('app')
    .controller('host.views.hositalizationExclusions', HospitalizationExclusionsController);

  HospitalizationExclusionsController.$inject = [
    'abp.services.app.hospitalizationExclusion',
    'abp.services.app.commonLookup',
  ];

  function HospitalizationExclusionsController(hospitalizationExclusionSvc, commonLookupSvc) {
    const vm = this;
    vm.serviceTypeExclusions = [];
    vm.loading = 0;
    vm.accountOwnerId = null;

    vm.hasExclusionListForSpecialist = abp.setting.getBoolean(
      'Hms.Feature.ExclusionListForSpecialist'
    );

    vm.getExclusions = getExclusions;

    init();

    function init() {
      getAccountOwners();
      getExclusions();
    }

    function getExclusions(accountOwnerId) {
      vm.loading += 1;
      hospitalizationExclusionSvc
        .getExclusions({
          accountOwnerId,
        })
        .success((data) => {
          vm.serviceTypeExclusions = data.items;
        })
        .finally(() => {
          vm.loading -= 1;
        });
    }

    function getAccountOwners() {
      if (!vm.hasExclusionListForSpecialist) return;

      vm.loading += 1;
      commonLookupSvc
        .getAccountOwners()
        .success((data) => {
          vm.accountOwners = data;
          const defaultOwner =
            vm.accountOwners.find((a) =>
              a.name.toLowerCase().startsWith('healthmetrics sdn bhd')
            ) || vm.accountOwners[0];

          vm.accountOwnerId = defaultOwner?.id;
        })
        .finally(() => {
          vm.loading -= 1;
        });
    }
  }
})();
